import apiService from "./BaseApi";

const BASE_NOTIFY_URL = "/notify"

const NotificationsClickSignService = {
    notifyAllSigners: async (idEnvelope) => apiService.post(`${BASE_NOTIFY_URL}/all/${idEnvelope}`),
    notifySigner: async (idEnvelope, idSigner) => apiService.post(`${BASE_NOTIFY_URL}/signer/${idEnvelope}/${idSigner}`)
}

export default NotificationsClickSignService;